export default "https://cdn.questicon.mathletics.com/assets/images/keycap-d7c6f72af7bcff7916489075b4b52f1d.png";